"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetFeatures = GetFeatures;
exports.FindNativeFeature = FindNativeFeature;
exports.FindNativeTheme = FindNativeTheme;
exports.GetIframeAndNativeEditors = GetIframeAndNativeEditors;
exports.GetIframeEditors = GetIframeEditors;
exports.GetSuperNoteFeature = GetSuperNoteFeature;
exports.GetPlainNoteFeature = GetPlainNoteFeature;
exports.GetNativeThemes = GetNativeThemes;
exports.GetDarkThemeFeature = GetDarkThemeFeature;
exports.GetDeprecatedEditors = GetDeprecatedEditors;
const NativeFeatureIdentifier_1 = require("./NativeFeatureIdentifier");
const ServerFeatures_1 = require("../Lists/ServerFeatures");
const ClientFeatures_1 = require("../Lists/ClientFeatures");
const DeprecatedFeatures_1 = require("../Lists/DeprecatedFeatures");
const ExperimentalFeatures_1 = require("../Lists/ExperimentalFeatures");
const IframeEditors_1 = require("../Lists/IframeEditors");
const Themes_1 = require("../Lists/Themes");
const NativeEditors_1 = require("../Lists/NativeEditors");
const ComponentArea_1 = require("../Component/ComponentArea");
function GetFeatures() {
    return [
        ...(0, ServerFeatures_1.serverFeatures)(),
        ...(0, ClientFeatures_1.clientFeatures)(),
        ...(0, Themes_1.themes)(),
        ...(0, NativeEditors_1.nativeEditors)(),
        ...(0, IframeEditors_1.IframeEditors)(),
        ...(0, ExperimentalFeatures_1.experimentalFeatures)(),
        ...(0, DeprecatedFeatures_1.GetDeprecatedFeatures)(),
    ];
}
function FindNativeFeature(identifier) {
    return GetFeatures().find((f) => f.identifier === identifier);
}
function FindNativeTheme(identifier) {
    return (0, Themes_1.themes)().find((t) => t.identifier === identifier);
}
function GetIframeAndNativeEditors() {
    return [...(0, IframeEditors_1.IframeEditors)(), ...(0, NativeEditors_1.nativeEditors)()];
}
function GetIframeEditors() {
    return (0, IframeEditors_1.IframeEditors)();
}
function GetSuperNoteFeature() {
    return FindNativeFeature(NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SuperEditor);
}
function GetPlainNoteFeature() {
    return FindNativeFeature(NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.PlainEditor);
}
function GetNativeThemes() {
    return (0, Themes_1.themes)();
}
function GetDarkThemeFeature() {
    return (0, Themes_1.themes)().find((t) => t.identifier === NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DarkTheme);
}
function GetDeprecatedEditors() {
    return (0, DeprecatedFeatures_1.GetDeprecatedFeatures)().filter((f) => f.area === ComponentArea_1.ComponentArea.Editor);
}
